export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref11814.66284981.jpg";